module.exports = __webpack_public_path__ + "img/ring_g_o_0_0@3x.788c501a.png";